// extracted by mini-css-extract-plugin
export default {"fileNameWrap":"styles_fileNameWrap__MCZ2t","documentNameTooltip":"styles_documentNameTooltip__zIwyN","documentName":"styles_documentName__UqsSe"};